<template>
  <v-app id="signage">
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
export default class Signage extends Vue {}
</script>

<style scoped>
#signage {
  font-family: 'Roboto', sans-serif;
}
</style>
